const buildTimeFallbackByEnv = {
  local: {
    API_URL: 'http://localhost:9091',
    STRIPE_KEY: 'pk_test_meTYAJRMzS0h6NmNdgW6nx6p',
    APP_ENV: 'local',
  },
  development: {
    API_URL: 'https://stage3-payments-api.chaserhq.com',
    STRIPE_KEY: 'pk_test_meTYAJRMzS0h6NmNdgW6nx6p',
    APP_ENV: 'development',
  },
  production: {
    API_URL: 'https://api.statement-gateway.com',
    STRIPE_KEY: 'pk_live_YaIn45MzODKq5VY9JjpcaDzf',
    APP_ENV: 'production',
  },
};

const runtimeEnv = typeof window !== 'undefined' ? window.__ENV__ : null;
const buildTimeEnv =
  buildTimeFallbackByEnv[process.env.REACT_APP_ENV] || buildTimeFallbackByEnv.production;
const env = runtimeEnv || buildTimeEnv;

const config = {
  apiUrl: env.API_URL || 'http://localhost:9091',
  stripeKey: env.STRIPE_KEY || '',
  sentryDsn: env.SENTRY_DSN || process.env.REACT_APP_SENTRY_DSN || '',
  appEnv: env.APP_ENV || 'production',
  nodeEnv: process.env.NODE_ENV || 'production',
};

module.exports = config;
